import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { Box, Container, Typography, Paper } from '@mui/material';

const Login: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Network Tools
          </Typography>
          <Typography component="h2" variant="h6" align="center" color="textSecondary" paragraph>
            Sign in to your account
          </Typography>
          <Box sx={{ mt: 3 }}>
            <SignIn 
              appearance={{
                elements: {
                  rootBox: "mx-auto",
                  card: "shadow-none",
                }
              }}
              forceRedirectUrl="/dashboard"
              signUpUrl="/sign-up"
            />
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;